import { Formik, FormikProps } from 'formik'
import * as React from 'react'
import { Link, Redirect, RouteComponentProps } from 'react-router-dom'
import * as Yup from 'yup'
import { isTokenValid } from '../../utils/auth'
import Logo from '../icons/ui/Logo'
import NewPasswordForm from './NewPasswordForm'
import { IChangePasswordObj } from '../../types'
import { RecoveryTokenStatuses } from '../../constants/authentication'

interface INewPasswordFormikForm
  extends RouteComponentProps<{ token: string; userId: string; organizationId: string }> {
  isFetching: boolean
  isFetchSuccess: boolean
  recoverPasswordTokenStatus: string
  isLogged: boolean
  handleSubmit: (data: IChangePasswordObj) => void
  handleCheckToken: (token: string) => void
  acceptTeamInvite: (userId: string, organizationId: string) => void
}

interface IInvitationPaneState {
  timer: number
}

interface IValues {
  password: string
  passwordConfirmation: string
}

const NewPasswordFormWrap = (formikProps: FormikProps<any>) => <NewPasswordForm {...formikProps} />

const handleSubmit = (handleSubmit: (data: IChangePasswordObj) => void, token: string) => (
  values: IValues,
  { setFieldError }: { setFieldError: (field: string, message: string) => void }
) => {
  const { password, passwordConfirmation } = values
  if (password === passwordConfirmation) {
    handleSubmit({
      password,
      passwordConfirmation,
      passwordRecoveryToken: token
    })
  } else {
    setFieldError('password', 'New password and password confirmation must be equal')
  }
}

class InvitationPaneForm extends React.Component<INewPasswordFormikForm, IInvitationPaneState> {
  constructor(props: INewPasswordFormikForm) {
    super(props)
    this.state = {
      timer: 3
    }
  }

  public componentDidMount() {
    this.props.handleCheckToken(this.props.match.params.token)
  }

  public componentDidUpdate(prevProps: INewPasswordFormikForm) {
    if (
      prevProps.isFetching &&
      !this.props.isFetching &&
      this.props.recoverPasswordTokenStatus === RecoveryTokenStatuses.IS_VALID
    ) {
      this.props.acceptTeamInvite(this.props.match.params.userId, this.props.match.params.organizationId)
    }
    if (this.props.isFetchSuccess) {
      const interval = setInterval(() => {
        if (this.state.timer > 0) {
          this.setState({ timer: this.state.timer - 1 })
        } else {
          clearInterval(interval)
          this.props.history.push('/auth')
        }
      }, 1000)
    }
  }

  public render() {
    if (this.props.isLogged || isTokenValid()) {
      return <Redirect to={`/trips`} />
    }

    return (
      <div className='col-12 absolute top-0 bottom-0 left-0 right-0 flex flex-wrap direction-column justify-center items-center bg-green'>
        <div>
          <Logo className='margin-auto block icon--89x137' />
          <div className='fs-18 font-white bold center mt2'>Welcome to GOIN'</div>
          {this.props.isFetching && <div className='h3 font-white bold center mt2'>Wait</div>}
          {this.props.isFetchSuccess && (
            <div className='w415 mt4'>
              <div className='fs-18 font-white bold center'>Password was set!</div>
              <div className='fs-12 font-white mt1 center'>
                <Link className='fs-15 font-white mt1 center ml1 bb-white' to='/auth'>
                  You will be redirected in {this.state.timer} seconds...
                </Link>
              </div>
            </div>
          )}
          {this.props.recoverPasswordTokenStatus === RecoveryTokenStatuses.IS_NOT_VALID && (
            <div className='fs-18 font-white bold center mt2'>Token is invalid!</div>
          )}
          {this.props.recoverPasswordTokenStatus === RecoveryTokenStatuses.IS_VALID && (
            <Formik
              initialValues={{ password: '', passwordConfirmation: '' }}
              validationSchema={Yup.object().shape({
                password: Yup.string().required('New password'),
                passwordConfirmation: Yup.string().required('New password again')
              })}
              onSubmit={handleSubmit(this.props.handleSubmit, this.props.match.params.token)}
              render={NewPasswordFormWrap}
            />
          )}
        </div>
      </div>
    )
  }
}

export default InvitationPaneForm



// WEBPACK FOOTER //
// ./src/components/authentication/InvitationPaneForm.tsx